import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-label-chip',
  standalone: true,
  imports: [MatChipsModule, NgClass],
  templateUrl: './label-chip.component.html',
  styleUrls: ['./label-chip.component.css']
})
export class LabelChipComponent {
  @Input() status!: string;

  getLabelClass(): string {
    switch (this.status) {
      // status
      case '受付': return 'chip-new';
      case '確認中': return 'chip-confirmation';
      case '対応中': return 'chip-in-progress';

      case '出金額確定': return 'chip-withdrawal-fixed';
      case '振替確定': return 'chip-withdrawal-fixed';
      case '出金済': return 'chip-withdrawal-done';

      case '回答済': return 'chip-answered';
      case '処理済': return 'chip-answered';

      case '入金待ち': return 'chip-waiting';

      case '完了': return 'chip-completed';

      case 'キャンセル': return 'chip-canceled';
      case '取消': return 'chip-canceled';

      // priority
      case '通常': return 'chip chip-normal';
      case '優先': return 'chip chip-priority';
      case '緊急': return 'chip chip-emergency';

      default: return 'chip-default';
    }
  }
}
